<template>
    <modal dialog="modal-lg" class="dark-top" :footer="true">
        <div slot="title">
            <h2>Edit Origin</h2>
        </div>
        <div slot="body">
            <div class="col-sm-12 py-3">
                <origins-form :origin="tempOrigin"></origins-form>
                <!-- <div class="d-flex justify-content-end">
                    <button class="btn action" @click="deleteChannel(tempOrigin)">Delete</button>
                </div> -->
            </div>
        </div>

        <div slot="footer" class="d-flex align-items-center justify-content-end">
            <button type="button" class="btn cancel wider mr-3" @click="close">Cancel</button>
            <button type="button" class="btn wider mr-3" @click="save">Save</button>
        </div>
    </modal>
</template>

<script>
    import Modal from '../Modal'
    import originsForm from './originsForm'
    import { mapActions, mapGetters } from 'vuex'

    export default {
        data: function() {
            return {
                tempOrigin: null
            }
        },
        created: function() {
            this.tempOrigin = JSON.parse(JSON.stringify(this.getSelectedOrigin))
        },
        computed: {
            ...mapGetters([
                'getSelectedOrigin'
            ])
        },
        methods: {
            ...mapActions([
                'closeModal',
                'setSelectedOrigin',
                'deleteOrigin',
                'updateOrigin',
                'downloadOrigins'
            ]),
            deleteChannel: function(origin) {
                this.deleteOrigin(origin)
            },
            save: function() {
                this.updateOrigin(this.tempOrigin).then(success => {
                    if(success == true){
                        this.closeModal();
                        this.downloadOrigins();
                    }
                })
            },
            close: function() {
                this.setSelectedOrigin(null)
                this.closeModal();
            },
        },
        components: {
            Modal,
            originsForm
        }
    }
</script>

<style lang="scss" scoped>
    .langPicker{
        width: 250px;
    }
</style>



// WEBPACK FOOTER //
// editOrigin.vue?3d9151f8